/* ===== NASHIRA COLLECTION RUNTIME ===== */
(function(){
  'use strict';

  function toast(msg){
    var t = document.getElementById('ns-toast');
    if(!t){
      t = document.createElement('div');
      t.id = 'ns-toast';
      t.style.cssText = 'position:fixed;bottom:90px;left:50%;transform:translateX(-50%) translateY(160px);background:#2a1810;color:#f7f0e4;padding:15px 30px;font-size:12px;letter-spacing:.14em;text-transform:uppercase;z-index:200;transition:.4s;border:1px solid #bf9b48;font-family:Mukta,sans-serif';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(window._nstt);
    window._nstt = setTimeout(function(){ t.style.transform = 'translateX(-50%) translateY(160px)'; }, 2400);
  }

  function initCollection(root){
    var scope = root || document;

    // filter drawer (mobile)
    var openBtns = scope.querySelectorAll('[data-ns-filter-open]');
    var closeBtns = scope.querySelectorAll('[data-ns-filter-close]');
    var filters = scope.querySelector('[data-ns-filters]');
    var scrim = scope.querySelector('[data-ns-filter-scrim]');
    function setDrawer(open){
      if(filters) filters.classList.toggle('ns-open', open);
      if(scrim) scrim.classList.toggle('ns-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    var sortSheet = scope.querySelector('[data-ns-sortsheet]');
    var sortOpenBtns = scope.querySelectorAll('[data-ns-sort-open]');
    var sortCloseBtns = scope.querySelectorAll('[data-ns-sort-close]');

    function setSortSheet(open){
      if(sortSheet){
        sortSheet.classList.toggle('ns-open', open);
        sortSheet.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
      if(scrim) scrim.classList.toggle('ns-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    function closeAll(){ setDrawer(false); setSortSheet(false); }

    openBtns.forEach(function(b){
      b.addEventListener('click', function(){ setSortSheet(false); setDrawer(true); });
    });
    closeBtns.forEach(function(b){
      // submit buttons close via navigation; only the X should preventDefault
      if(b.type !== 'submit') b.addEventListener('click', function(){ setDrawer(false); });
    });
    sortOpenBtns.forEach(function(b){
      b.addEventListener('click', function(){ setDrawer(false); setSortSheet(true); });
    });
    sortCloseBtns.forEach(function(b){ b.addEventListener('click', function(){ setSortSheet(false); }); });
    if(scrim) scrim.addEventListener('click', closeAll);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeAll(); });

    // sort sheet options navigate the same way the desktop select does
    scope.querySelectorAll('[data-ns-sort-opt]').forEach(function(opt){
      opt.addEventListener('click', function(){
        var url = new URL(window.location);
        url.searchParams.set('sort_by', opt.getAttribute('data-ns-sort-opt'));
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });

    // sticky bar reveals once the grid is in play, hides at the very bottom
    var cbar = scope.querySelector('[data-ns-cbar]');
    var gridWrap = scope.querySelector('[data-ns-grid-wrap]');
    if(cbar && gridWrap){
      var syncBar = function(){
        var r = gridWrap.getBoundingClientRect();
        var started = r.top < window.innerHeight * 0.7;
        var ended = r.bottom < window.innerHeight * 0.4;
        cbar.classList.toggle('ns-show', started && !ended);
      };
      window.addEventListener('scroll', syncBar, {passive:true});
      window.addEventListener('resize', syncBar, {passive:true});
      syncBar();
    }

    // sort -> reload with sort_by param
    var sortSelect = scope.querySelector('[data-ns-sort]');
    if(sortSelect){
      sortSelect.addEventListener('change', function(){
        var url = new URL(window.location);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }

    // filter form: on desktop, auto-submit on change; on mobile, Apply submits
    var form = scope.querySelector('[data-ns-filter-form]');
    if(form){
      var isMobile = window.matchMedia('(max-width:900px)').matches;
      form.addEventListener('change', function(e){
        if(!window.matchMedia('(max-width:900px)').matches){
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
      form.addEventListener('submit', function(e){
        // build clean query string from checked inputs, preserving sort
        e.preventDefault();
        var params = new URLSearchParams();
        var currentSort = new URL(window.location).searchParams.get('sort_by');
        if(currentSort) params.set('sort_by', currentSort);
        form.querySelectorAll('input').forEach(function(input){
          if((input.type === 'checkbox' && input.checked) || (input.type === 'number' && input.value)){
            params.append(input.name, input.value);
          }
        });
        window.location.assign(window.location.pathname + '?' + params.toString());
      });
    }

    // Quick add and wishlist are owned by ns-card.js, which binds the
    // attributes the card snippet actually emits (data-ns-qadd / data-ns-wish).
    // The handlers that used to live here bound a selector the markup never
    // had, and double-bound the wishlist so every click toggled twice.
  }

  function boot(){ initCollection(document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ initCollection(e.target); });
})();
